import React from "react";
import styles from "./index.module.scss";

export interface DayOption {
  label: string;
  value: string;
}

interface DaySelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  options?: DayOption[];
}

const DEFAULT_DAYS: DayOption[] = [
  { label: "Sun", value: "sun" },
  { label: "Mon", value: "mon" },
  { label: "Tue", value: "tue" },
  { label: "Wed", value: "wed" },
  { label: "Thu", value: "thu" },
  { label: "Fri", value: "fri" },
  { label: "Sat", value: "sat" },
];

const FULL_DAY_NAMES: Record<string, string> = {
  sun: "Sunday",
  mon: "Monday",
  tue: "Tuesday",
  wed: "Wednesday",
  thu: "Thursday",
  fri: "Friday",
  sat: "Saturday",
};

export default function DaySelector({
  value,
  onChange,
  options = DEFAULT_DAYS,
}: DaySelectorProps): React.ReactElement {
  const selectedDay = options.find((d) => d.value === value);

  return (
    <div>
      <div className={styles.daySelector}>
        {options.map((day) => (
          <button
            key={day.value}
            type="button"
            className={`${styles.dayButton} ${value === day.value ? styles.dayButtonActive : ""}`}
            onClick={() => onChange?.(day.value)}
          >
            <span className={styles.dayButtonRadio}>
              {value === day.value && (
                <span className={styles.dayButtonRadioInner} />
              )}
            </span>
            <span className={styles.dayButtonLabel}>{day.label}</span>
          </button>
        ))}
      </div>
      {selectedDay && (
        <div className={styles.daySelectorHint}>
          Every {FULL_DAY_NAMES[selectedDay.value] || selectedDay.label}
        </div>
      )}
    </div>
  );
}
